import React from 'react'

import { useNavigation } from '@react-navigation/native'
import { B2, BTN, SH2, SH3, Stack, XStack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import MailOutlined from '@zet/design-system/svg/MailOutlined'
import PhoneOutlined from '@zet/design-system/svg/PhoneOutlined'
import WorkOutlined from '@zet/design-system/svg/WorkOutlined'
import { useUserContext } from '@zet/feature-user'

import { i18n } from '../../localization'
import CompanyLined from '../../svg/CompanyLined'

const MyProfile = () => {
  const navigation = useNavigation()
  const { data } = useUserContext()

  return (
    <Stack className="border-grays-30 border-b border-t-2 px-3 py-3">
      <XStack className="items-center justify-between">
        <SH2>{i18n.t('accountDetails.myProfile')}</SH2>
        <Pressable onPress={() => navigation.navigate('EditDetails')}>
          <BTN className="text-primary-100">
            {i18n.t('accountDetails.editDetails')}
          </BTN>
        </Pressable>
      </XStack>

      <XStack className="mt-4 items-center">
        <Stack className="mr-2">
          <PhoneOutlined size={20} />
        </Stack>
        <Stack>
          <B2 className="text-grays-60">
            {i18n.t('accountDetails.registeredNum')}
          </B2>
          <SH3>+91-{data?.phoneNumber}</SH3>
        </Stack>
      </XStack>

      {data?.emailAddress && (
        <XStack className="mt-4 flex-row items-center">
          <Stack className="mr-2">
            <MailOutlined size={20} />
          </Stack>
          <Stack>
            <B2 className="text-grays-60">{i18n.t('accountDetails.email')}</B2>
            <SH3>{data?.emailAddress}</SH3>
          </Stack>
        </XStack>
      )}

      <XStack className="mt-4 items-center">
        <Stack className="mr-2">
          <WorkOutlined size={22} />
        </Stack>
        <Stack>
          <B2 className="text-grays-60">
            {i18n.t('accountDetails.occupation')}
          </B2>
          <SH3>{i18n.t('accountDetails.occupationType')}</SH3>
        </Stack>
      </XStack>

      <XStack className="mt-4 items-center">
        <Stack className="mr-2">
          <CompanyLined />
        </Stack>
        <Stack>
          <B2 className="text-grays-60">{i18n.t('accountDetails.company')}</B2>
          <SH3>{data?.companyName}</SH3>
        </Stack>
      </XStack>

      {/* <Stack className="mt-4 flex-row items-center">
        <Stack className="mr-2">
          <LocationOutlined />
        </Stack>
        <Stack>
          <B2 className="text-grays-60">
            {i18n.t('accountDetails.companyAddress')}
          </B2>
          <SH3 numberOfLines={2}>
            {data?.data?.companyAddress ||
              'some building, nearby colony, sector, city, state - 560034'}
          </SH3>
        </Stack>
      </Stack> */}
    </Stack>
  )
}

export default MyProfile
